// extracted by mini-css-extract-plugin
module.exports = {"responsive-image":"ResponsiveImage_responsive-image__OyMg_","responsive-image__img":"ResponsiveImage_responsive-image__img__z4G6m"};